import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useStore, useStoreId } from '@thd-nucleus/experience-context';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { VendorCollections } from './VendorCollections';

export const VendorCollectionsContainer = (props) => {
  const { storeId } = useStore();
  const defaultVariables = {
    storeId,
    skipSpecificationGroup: false,
    skipInstallServices: true,
    skipSubscribeAndSave: true,
    skipKPF: true
  };

  return (
    <QueryProvider
      cacheKey="kitchen-cabinets-desktop"
      defaultVariables={defaultVariables}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <VendorCollections {...props} />
    </QueryProvider>
  );
};

VendorCollectionsContainer.propTypes = {};
